const PLATFORM_COLORS = ["#7F77DD", "#378ADD", "#1D9E75", "#E24B4A", "#F59E0B"];

const ThirdPartyBreakdown = ({ breakdown }) => {
  const maxRaw = Math.max(...breakdown.map((b) => b.amount_raw || 0), 1);

  return (
    <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-4">
      <p className="text-xs font-semibold text-gray-700 uppercase tracking-wider mb-3">
        Third Party Channel Breakdown
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-3">
        {breakdown.map((item, i) => {
          const widthPct = ((item.amount_raw / maxRaw) * 100).toFixed(1);
          const color = PLATFORM_COLORS[i % PLATFORM_COLORS.length];
          return (
            <div key={i}>
              <div className="flex items-center justify-between mb-1">
                <div className="flex items-center gap-1.5">
                  <span className="w-2 h-2 rounded-full flex-shrink-0" style={{ background: color }} />
                  <span className="text-xs text-gray-500 font-medium">{item.platform}</span>
                </div>
                <div className="text-right">
                  <span className="text-xs font-semibold text-gray-700">{item.amount}</span>
                  <span className="text-xs text-gray-400 ml-1">· {item.orders} orders</span>
                </div>
              </div>
              <div className="w-full bg-gray-100 rounded-full h-1">
                <div
                  className="h-1 rounded-full transition-all"
                  style={{ width: `${widthPct}%`, background: color }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ThirdPartyBreakdown;
